import { action, makeObservable, observable } from 'mobx';
export class PaymentController {
    constructor() {
        this.setPayment = (type) => {
            this.type = type;
        };
        this.type = 'PAY_ADMIT';
        makeObservable(this, {
            type: observable,
            setPayment: action,
        });
    }
}
